<div class="stepper-template">
  <div class="stepper-template__stepper">
    <div class="stepper-template__stepper__content">
      <div class="stepper">
        <div class="stepper__content">
          <ng-template ngFor let-tab [ngForOf]="steps" let-i="index">
            <div class="stepper_tab">
              <div
                [ngClass]="{
                  stepper_tab_index: true,
                  active: actualStep === i + 1,
                  cheked_tab: actualStep > i + 1
                }"
              >
                {{ actualStep > i + 1 ? '&#10003;' : i + 1 }}
              </div>
              <div [ngClass]="{ stepper_tab_title: true, active: actualStep === i + 1 }">
                <pichincha-typography
                  variant="prelo"
                  weight="400"
                  size="14px"
                  line-height="20px"
                  [color]="actualStep === i + 1 ? 'bp-primary-blue500' : 'bp-grayScale400'"
                  align="center"
                >
                  {{ tab }}
                </pichincha-typography>
              </div>
            </div>
            <div class="stepper_divider" *ngIf="i + 1 !== steps.length"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
